export enum LeftInBuildingScanModal {
  INVALID_BARCODE = "INVALID_BARCODE",
  GAYLORD_NOT_FOUND = "GAYLORD_NOT_FOUND",
  INVALID_LIB_REASON = "INVALID_LIB_REASON",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  REASON_CODE_MISSING = "REASON_CODE_MISSING",
  REASON_DETAILS_MISSING = "REASON_DETAILS_MISSING",
  REASON_DETAILS_TOO_LONG = "REASON_DETAILS_TOO_LONG",
}
